import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('data', 'publicConstants');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'public_constants',
  type: 'get',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/data/publicConstants.js